import axios from "./axiosInstance";
import { url } from "./url";

export const fetchReferralAmount = async () => {
  try {
    const response = await axios.post(`${url.apiUrl}public/referral-amoount`);
    return response.data?.item || null;
  } catch (error) {
    console.error("Error fetching referral amount:", error);
    return null;
  }
};
